/**
 *@author       罗朝军
 *@date         2021/12/03 11:55
 *@Copyright    天源迪科信息技术股份有限公司
 *@Description
 */
const shoppingRouter = [
  {
    path: "/login",
    component: () => import("@/app/login/views/login.vue"),
    meta: {
      isShowShopHead: true,
      isShowPageFooter: true //是否展示页脚
    },
    name: "login"
  }
];

export default shoppingRouter;
